"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurAgencysDna() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="223565" id="the-moza-philosophy" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/20 rounded-full blur-[120px]"></div>
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_center,var(--color-primary)_1px,transparent_1px)] bg-[size:32px_32px]"></div>
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Badge variant="default" className="mb-8 px-4 py-1.5 text-xs uppercase tracking-[0.2em] bg-secondary text-secondary-foreground font-default rounded-none">
          The Philosophy
        </Badge>

        <p className="font-default text-2xl md:text-3xl lg:text-[32px] leading-relaxed md:leading-relaxed font-light text-foreground max-w-[800px] text-balance italic">
          "A true smart home isn't about how many devices are in your home; it is
          about your home working for you so well that you don't realize the devices in your home."
        </p>

        <div className="mt-12 w-px h-24 bg-primary/20"></div>

        <p className="mt-12 font-default text-base md:text-lg text-muted-foreground max-w-[600px] leading-relaxed">
          Moza Casa bridges the gap between sophisticated Apple HomeKit
          technology and the art of simple living, creating environments that
          breathe with you.
        </p>
      </div>
    </section>;
}